import { Injectable } from '@angular/core';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import { LocalStorageKey } from '@ddt-web/generic-utils';
import { PartnerQueryParamKey } from '@ddt-web/url';
import { PartnerConstants, UserDataService, UserProfile } from '@ddt-web/user-data';
import * as get from 'lodash/get';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * TODO Waris: Temporary service to handle the entitlement before it moves totally on backend by Q2
 */
@Injectable({
	providedIn: 'root'
})
export class ModelsEntitlementService {
	@InjectConfig(SharedConfigKey.ENABLE_EXTSSO_CHECK) private readonly isExtSsoCheckEnabled: boolean = false;

	constructor(private userDataService: UserDataService) { }

	public isEligibleForBLKManagedModels(): Observable<boolean> {
		return this.userDataService.getUserProfile().pipe(map((userProfile) => {
			const ssoPartnerName = get(userProfile, PartnerConstants.SSO_TOKEN_PATH, localStorage.getItem(LocalStorageKey.SsoInitiatedFrom));
			const testPartnerFirm = this.getTestPartnerFirmParam(userProfile);

			let isPartnerWithBLKManagedModel = !!ssoPartnerName && PartnerConstants.MANAGED_MODELS_PARTNERS.includes(ssoPartnerName);
			if (this.isExtSsoCheckEnabled) {
				const isExternalSso = get(userProfile, PartnerConstants.EXT_SSO_TOKEN_PATH, localStorage.getItem(LocalStorageKey.ExtSso)) === 'true';
				isPartnerWithBLKManagedModel = !!ssoPartnerName && isExternalSso && PartnerConstants.MANAGED_MODELS_PARTNERS.includes(ssoPartnerName);
			}
			const isTestPartnerFirmWithManagedModel = PartnerConstants.MANAGED_MODELS_PARTNERS.includes(testPartnerFirm);
			return isPartnerWithBLKManagedModel || isTestPartnerFirmWithManagedModel;
		}));
	}

	public isEligibleForThirdPartyModels(): Observable<boolean> {
		return this.userDataService.getUserProfile().pipe(map((userProfile) => {
			const ssoPartnerName = get(userProfile, PartnerConstants.SSO_TOKEN_PATH, localStorage.getItem(LocalStorageKey.SsoInitiatedFrom));
			const testPartnerFirm = this.getTestPartnerFirmParam(userProfile);

			if (this.isExtSsoCheckEnabled) {
				const isExternalSso = get(userProfile, PartnerConstants.EXT_SSO_TOKEN_PATH, localStorage.getItem(LocalStorageKey.ExtSso)) === 'true';
				return (!!ssoPartnerName && isExternalSso) || !!testPartnerFirm;
			}
			return !!ssoPartnerName || !!testPartnerFirm;
		}));
	}

	private getTestPartnerFirmParam(userProfile: UserProfile): string {
		return (get(userProfile, 'usAuthAccessLevel') === 'INTERNAL' || userProfile.internalUser)
			? new URL(window.location.href).searchParams.get(PartnerQueryParamKey.TEST_PARTNER_FIRM) : '';
	}
}
